// extracted by mini-css-extract-plugin
export var deliveryRow = "_qf-a";
export var fixedHeight = "_qf-4";
export var freightLogo = "_qf-9";
export var fullWidth = "_qf-3";
export var priceColumn = "_qf-5";
export var radioSelected = "_qf-7";
export var radioUnselected = "_qf-6";
export var selectedOption = "_qf-2";
export var selectedOptionContainer = "_qf-1";
export var selection = "_qf-0";
export var tallSkeletonText = "_qf-8";